import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m12.625 11.575-3.9 3.9a.948.948 0 0 0-.275.7.95.95 0 0 0 .275.7.948.948 0 0 0 .7.275.948.948 0 0 0 .7-.275l4.6-4.6c.1-.1.17-.208.213-.325.041-.117.062-.242.062-.375s-.02-.258-.063-.375a.877.877 0 0 0-.212-.325l-4.6-4.6a.948.948 0 0 0-.7-.275.948.948 0 0 0-.7.275.948.948 0 0 0-.275.7.95.95 0 0 0 .275.7l3.9 3.9Z" }));
const ForwardRef = forwardRef(SvgChevronRight);
export default ForwardRef;
